"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCell = exports.TableCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var table_cell_title_1 = require("./table-cell-title");
exports.TableCellDefaultProps = {
  spec: {
    title: ''
  }
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " 0;\n    border-bottom: 1px solid ", ";\n    margin: 0 ", ";\n    display: block;\n    align-items: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    background-position: bottom left;\n\n    ", "\n\n    ", "\n  "], ["\n    padding: ", " 0;\n    border-bottom: 1px solid ", ";\n    margin: 0 ", ";\n    display: block;\n    align-items: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    background-position: bottom left;\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(4), function (props) {
    return props.spec && props.spec.justify && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      justify-content: ", ";\n    "], ["\n      justify-content: ", ";\n    "])), props.spec.justify);
  }, function (props) {
    return props.spec && props.spec.isLast && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-bottom: none;\n    "], ["\n      border-bottom: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    background-image: none;\n    margin: 0;\n    border: none;\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    background-image: none;\n    margin: 0;\n    border: none;\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), function (props) {
    return props.spec && props.spec.pad === "all" && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3));
  }, function (props) {
    return props.spec && props.spec.pad === "none" && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
  }, function (props) {
    return props.spec && props.spec.pad === "right" && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: 0 ", " 0 0;\n    "], ["\n      padding: 0 ", " 0 0;\n    "])), theme_1.theme.UNIT(3));
  }, function (props) {
    return props.spec && props.spec.pad === "left" && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding: 0 0 0 ", ";\n    "], ["\n      padding: 0 0 0 ", ";\n    "])), theme_1.theme.UNIT(3));
  }, function (props) {
    return props.spec && props.spec.pad === "top" && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding: ", " 0 0 0;\n    "], ["\n      padding: ", " 0 0 0;\n    "])), theme_1.theme.UNIT(4));
  }, function (props) {
    return props.spec && props.spec.pad === "bottom" && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding: 0 0 ", " 0;\n    "], ["\n      padding: 0 0 ", " 0;\n    "])), theme_1.theme.UNIT(4));
  })
});
var InlineTitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: none;\n    padding-bottom: ", ";\n    color: ", ";\n\n    ", "\n  "], ["\n    display: none;\n    padding-bottom: ", ";\n    color: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(1.5), theme_1.theme.COLOR('dark'), function (props) {
    return props.spec && props.spec.isLast && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  InlineTitle: (0, styled_components_1.default)(table_cell_title_1.TableCellTitle)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), InlineTitleStyles)
};
var TableCell = function (props) {
  var className = props.className,
    children = props.children,
    spec = props.spec;
  return react_1.default.createElement(My.Container, {
    spec: spec,
    className: className
  }, spec.title && react_1.default.createElement(My.InlineTitle, {
    spec: spec
  }), children);
};
exports.TableCell = TableCell;
exports.TableCell.defaultProps = exports.TableCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;